import { useQuery } from '@tanstack/react-query';
import { resources } from '../../core/services/resources';
import type { AiAssistantRole } from '../../core/types/data-models';

/**
 * The AI Assistant Roles catalog (docs/AI-Assistant-Roles.md §5.1) — shared,
 * cached query so the chat sidebar's role picker and any AI Assistants
 * roster panel read the same data without duplicate requests.
 */
export function useAssistantRoles() {
  const query = useQuery({
    queryKey: ['aiAssistantRoles'],
    queryFn: () => resources.aiAssistantRoles.list({ pageSize: 100, sort: 'order' }),
    staleTime: 5 * 60 * 1000,
  });

  const roles: AiAssistantRole[] = (query.data?.data ?? []).filter((r) => r.status === 'Active');

  return { roles, isLoading: query.isLoading };
}
